import React from 'react'
import { Navigate, Outlet, useSearchParams } from 'react-router-dom'
import { useSelector } from 'react-redux';
import { AUTHENTICATED_ENTRY, REDIRECT_URL_KEY } from 'configs/AppConfig'

const PublicRoute = () => {
	const { token } = useSelector(state => state.auth)
	const [searchParams] = useSearchParams();
	// By vipul.singh@velsof.com on 29-04-2026 — honour ?redirect= deep link if already authenticated
	return token ? <Navigate to={searchParams.get(REDIRECT_URL_KEY) || AUTHENTICATED_ENTRY} /> : <Outlet />
}

export default PublicRoute